export default __webpack_public_path__ + "static/media/banner03.99377b45.png";